<template>
  <card-component title="Change Password" icon="lock">
    <form @submit.prevent="submit">
      <b-field horizontal label="Current password" message="Required. Your current password">
        <b-input
          name="passwordCurrent"
          type="password"
          v-model="form.passwordCurrent"
          required
          autcomplete="current-password"
        />
      </b-field>
      <hr />
      <b-field horizontal label="New password" message="Required. New password">
        <b-input
          name="password"
          type="password"
          v-model="form.password"
          required
          autocomplete="new-password"
        />
      </b-field>
      <b-field horizontal label="Confirm password" message="Required. New password one more time">
        <b-input
          name="passwordConfirm"
          type="password"
          v-model="form.passwordConfirm"
          required
          autocomplete="new-password"
        />
      </b-field>
      <hr />
      <b-field horizontal>
        <div class="control">
          <button
            @click.prevent="changePassword"
            class="button is-primary"
            :class="{'is-loading':isLoading}"
          >Submit</button>
        </div>
      </b-field>
    </form>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent';
import { password, required } from 'vuelidate/lib/validators';
export default {
  name: 'PasswordUpdateForm',
  components: {
    CardComponent,
  },
  data() {
    return {
      isLoading: false,
      form: {
        passwordCurrent: '',
        password: '',
        passwordConfirm: '',
      },
    };
  },
  validations: {
    form: {
      password: {
        required,
      },
      passwordCurrent: {
        required,
      },
      passwordConfirm: {
        required,
      },
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
  },
  methods: {
    // submit() {
    //   this.isLoading = true;
    //   setTimeout(() => {
    //     this.isLoading = false;
    //     this.$buefy.snackbar.open(
    //       {
    //         message: 'Updated',
    //         queue: false,
    //       },
    //       500
    //     );
    //   });
    // },
    changePassword() {
      this.$v.form.$touch();
      this.isLoading = true;
      this.$store
        .dispatch('auth/updateAuthPassword', this.form)
        .then(() => {
          this.$buefy.snackbar.open({
            message: `Password Changed Successfully`,
            queue: false,
          });

          this.form.passwordCurrent = '';
          this.form.password = '';
          this.form.passwordConfirm = '';

          this.isLoading = false;
        })
        .catch((errMessage) => {
          // console.log(errMessage);
          this.$buefy.snackbar.open({
            message: `Login Failed ${errMessage}`,
            queue: false,
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
